"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadStatusDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@goparrot/common");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const interface_1 = require("../interface");
class ReadStatusDto {
}
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, class_validator_1.IsEnum)(interface_1.StatusEnum, { always: true }),
    tslib_1.__metadata("design:type", String)
], ReadStatusDto.prototype, "status", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    tslib_1.__metadata("design:type", Object)
], ReadStatusDto.prototype, "locationStatuses", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    tslib_1.__metadata("design:type", Date)
], ReadStatusDto.prototype, "updatedAt", void 0);
exports.ReadStatusDto = ReadStatusDto;
//# sourceMappingURL=ReadStatusDto.js.map